module.exports = __webpack_public_path__ + "img/indexbc.f3c44d57.png";